const WHISH_PENDING_KEY = "mfg_whish_payment_result";
const LAST_ACTIVITY_STORAGE_KEY = "mfg_last_activity_at";

export function getQueryParamCI(search, name) {
  const params = new URLSearchParams(search || "");
  const wanted = String(name || "").toLowerCase();
  for (const [key, value] of params.entries()) {
    if (String(key).toLowerCase() === wanted) return value;
  }
  return null;
}

export function parseWhishReturnParams(search) {
  const result = String(getQueryParamCI(search, "result") || "").trim().toLowerCase();
  if (result !== "success" && result !== "failed") return null;
  const externalId = String(
    getQueryParamCI(search, "externalId") || getQueryParamCI(search, "externalid") || ""
  ).trim();
  return { result, externalId };
}

export function isTrustedMfginvestOrigin(origin) {
  try {
    const host = new URL(origin).hostname.toLowerCase();
    return (
      host === "localhost" ||
      host === "127.0.0.1" ||
      host === "mfginvest.com" ||
      host.endsWith(".mfginvest.com")
    );
  } catch (_) {
    return false;
  }
}

export function parseWhishReturnMessage(event) {
  const data = event?.data;
  if (!data || data.type !== "mfg-whish-return") return null;
  if (event.origin && event.origin !== "null" && !isTrustedMfginvestOrigin(event.origin)) {
    return null;
  }
  const result = String(data.result || "").trim().toLowerCase();
  if (result !== "success" && result !== "failed") return null;
  return {
    result,
    externalId: String(data.externalId || "").trim(),
  };
}

export function markWhishReturnActivity() {
  try {
    localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(Date.now()));
  } catch (_) {}
}

export function claimWhishReturnHandling(result, externalId = "") {
  const keys = [`mfg_whish_claimed_${result}`];
  if (externalId) keys.push(`mfg_whish_claimed_${result}_${externalId}`);
  try {
    const now = Date.now();
    for (const key of keys) {
      const prev = Number(sessionStorage.getItem(key) || 0);
      if (prev && now - prev < 60 * 1000) return false;
    }
    keys.forEach((key) => sessionStorage.setItem(key, String(now)));
  } catch (_) {}
  return true;
}

export function bootstrapWhishReturnFromUrl() {
  if (typeof window === "undefined") return;
  const parsed = parseWhishReturnParams(window.location.search);
  if (!parsed) return;

  stashWhishReturn(parsed.result, parsed.externalId);
  markWhishReturnActivity();

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const loggedIn = !!token && token !== "FIRST_TIME_LOGIN" && String(token).trim() !== "";
  if (!loggedIn) return;
  if (window.location.pathname === "/pages/dashboard") return;

  const search = window.location.search || "";
  window.history.replaceState(null, "", `/pages/dashboard${search}`);
}

export function stashWhishReturn(result, externalId = "") {
  try {
    sessionStorage.setItem(
      WHISH_PENDING_KEY,
      JSON.stringify({ result, externalId, at: Date.now() })
    );
  } catch (_) {}
}

export function consumeWhishReturn() {
  try {
    const raw = sessionStorage.getItem(WHISH_PENDING_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(WHISH_PENDING_KEY);
    const parsed = JSON.parse(raw);
    if (parsed?.result !== "success" && parsed?.result !== "failed") return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function peekWhishReturn() {
  try {
    const raw = sessionStorage.getItem(WHISH_PENDING_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}
